<template>
  <ol-map
    :timelines="timelines"
    :legends="legends"
    @click="onMapClick"
    :extent="extent"
    :projectValue="projectValue"
    @timelineChange="onTimelineChange"
    :unit="unit"
    :toolPosition="{ top: '10%' }"
  >
    <ol-view :zoom="14" :extent="extent" :padding="[20, 0, 20, 0]"></ol-view>

    <ol-layer-tile
      v-if="layerName !== ''"
      name="成果图层"
      :zIndex="8"
      :clip="clip"
    >
      <ol-source-tilewms v-if="layerName !== ''" :layers="layerName" />
    </ol-layer-tile>

    <ol-layer-tile name="地块图层" :zIndex="9" ref="landLayer">
      <ol-source-tilewms
        layers="henan:high_field_land"
        styles="land_no_mark_style"
        :filter="`project_id=${projectValue} and data_date=${dateValue}`"
        :clip="clip"
      />
    </ol-layer-tile>

    <!-- 地块高亮 -->
    <ol-geom-polygon
      name="highlight"
      :features="highlightObj"
      :zIndex="100"
      :effect="{ stroke: { color: 'red', width: 2 } }"
    />
    <ol-layer-tile name="边界图层" v-if="regionLayerShow" :zIndex="5">
      <ol-source-tilewms
        layers="henan:prod_region"
        styles="land_region_style"
        :filter="`region_id=${regionId} or parent_id=${regionId}`"
      />
    </ol-layer-tile>
    <template #tools>
      <div class="ol-map-tool-group m-t-sm" v-if="sequelId !== ''">
        <div class="ol-map-tool">
          <el-tooltip
            class="item"
            popper-class="my-custom-tooltip"
            effect="dark"
            content="长时间序列分析"
            placement="left"
          >
            <svg-icon
              icon-name="barchart"
              style="font-size: 15px"
              icon-class="ol-map-tool-icon"
              @click.native="openEchartsBarDialog()"
              iconColor="rgba(90, 234, 173, 1)"
            ></svg-icon>
          </el-tooltip>
        </div>
        <div class="ol-map-tool">
          <el-tooltip
            class="item"
            popper-class="my-custom-tooltip"
            effect="dark"
            content="图表"
            placement="left"
          >
            <svg-icon
              icon-name="pie"
              style="font-size: 15px"
              icon-class="ol-map-tool-icon"
              @click.native="openEchartsPieDialog()"
              iconColor="rgba(90, 234, 173, 1)"
            ></svg-icon>
          </el-tooltip>
        </div>
        <div class="ol-map-tool">
          <el-tooltip
            class="item"
            popper-class="my-custom-tooltip"
            effect="dark"
            content="表格"
            placement="left"
          >
            <svg-icon
              icon-name="table"
              icon-class="ol-map-tool-icon"
              @click.native="openTableDialog"
            ></svg-icon>
          </el-tooltip>
        </div>

        <div class="ol-map-tool">
          <el-tooltip
            class="item"
            popper-class="my-custom-tooltip"
            effect="dark"
            content="下载"
            placement="left"
          >
            <svg-icon
              icon-name="download"
              icon-class="ol-map-tool-icon"
              @click.native="onDownload"
            ></svg-icon>
          </el-tooltip>
        </div>
      </div>
    </template>
  </ol-map>
</template>

<script>
export default {
  name: "datasetMap",
  props: {
    timelines: {
      type: Array,
      default: () => [],
    },
    legends: {
      type: Array,
      default: () => [],
    },
    extent: {
      type: Array,
      default: () => [],
    },
    onMapClick: {
      type: Function,
      default: () => {},
    },
    onTimelineChange: {
      type: Function,
      default: () => {},
    },
    openEchartsPieDialog: {
      type: Function,
      default: () => {},
    },
    openEchartsBarDialog: {
      type: Function,
      default: () => {},
    },
    openTableDialog: {
      type: Function,
      default: () => {},
    },
    onDownload: {
      type: Function,
      default: () => {},
    },
    unit: {
      type: String,
      default: "",
    },
    projectValue: {
      type: String,
      default: "",
    },
    layerName: {
      type: String,
      default: "",
    },
    clip: {
      type: String,
      default: "",
    },
    dateValue: {
      type: String,
      default: "",
    },
    regionId: {
      type: String,
      default: "",
    },
    sequelId: {
      type: String,
      default: "",
    },
    highlightObj: {
      type: [String,Object],
      default: {},
    },
    regionLayerShow: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {},
  mounted() {
    
    
  }
};
</script>

<style lang="scss" scoped>
</style>